<template>
  <div class="">
    <div class="upload-div">
      <el-upload
        class=""
        drag
        accept=".xls,.xlsx,.XLS,.XLSX"
        action="/"
        :auto-upload="false"
        :on-remove="handleRemove"
        :file-list="fileList"
        :on-change="onChange"
        multiple
      >
        <i class="el-icon-upload"></i>
        <div class="el-upload__text">
          Arraste os arquivos aqui ou
          <em style="color: #e87305">clique para selecionar!</em>
        </div>
        <div class="el-upload__tip" slot="tip">
          <div class="standards-items" v-if="standardsVisibled">
            <div>
              <span style="font-weight: normal">Arquivos esperados:</span>
              <span
                style="margin-left: 10px"
                v-for="(item, index) in standards"
                :key="index"
                >{{ item.required ? `${item.name}*` : `${item.name}` }}</span
              >
            </div>
            <div @click="standardsVisibled = false">
              <b-icon class="icon-beaut" icon="x" font-scale="1.4"></b-icon>
            </div>
          </div>
          <div class="items-box">
            <div v-for="(item, index) in fileList" :key="index">
              <div :class="!item.error.status ? 'item' : 'item danger'">
                <div>
                  <div style="text-center">
                    <span class="item-name">{{ item.raw.name }}</span>
                    <span style="font-size: 11px; margin-left: 5px"
                      >({{ (item.size / 1024).toFixed() }}kb)</span
                    >
                  </div>
                  <div class="text-center" v-if="item.error.status">
                    <b-icon
                      class="text-danger"
                      style="margin-right: 5px"
                      icon="exclamation-circle-fill"
                      font-scale="0.7"
                    ></b-icon>
                    <span class="text-danger">{{ item.error.message }}</span>
                  </div>
                </div>
                <el-popover
                  placement="top"
                  width="300"
                  v-model="item.popVisible"
                  :ref="'popover' + index"
                >
                  <div class="confirm-items">
                    <div>
                      <b-icon
                        style="
                          margin-left: 10px;
                          margin-right: 10px;
                          color: #e87305;
                        "
                        class="icon-beaut"
                        icon="info-circle-fill"
                        font-scale="1"
                      ></b-icon>
                    </div>
                    <div>
                      <span style="word-break: break-word"
                        >Remover item da lista?</span
                      >
                      <p
                        style="
                          word-break: break-word;
                          margin-top: 10px;
                          font-size: 12px;
                        "
                      >
                        Após a remoção não será possível restaurar a lista.
                      </p>
                    </div>
                  </div>
                  <div style="text-align: right; margin: 0; margin-top: 5px">
                    <el-button
                      style="background: #eaeaea; color: #515151"
                      type="text"
                      @click="item.popVisible = false"
                      >cancelar</el-button
                    >
                    <el-button @click="handleDelete(index)"
                      >confirmar</el-button
                    >
                  </div>
                </el-popover>
                <b-icon
                  @click="
                    () => {
                      item.error.status
                        ? handleDelete(index)
                        : (item.popVisible = true);
                    }
                  "
                  class="icon-beaut"
                  icon="x"
                  font-scale="1.4"
                ></b-icon>
              </div>
            </div>
          </div>
          <div class="footer-menu-item">
            <el-tooltip
              slot="reference"
              content="Quantidade de planilhas para realizar a importação."
              placement="bottom"
            >
              <div
                style="cursor: help; font-size: 12px"
                @click="standardsVisibled = true"
              >
                <span v-if="fileList.length">
                  {{ fileList.length }} planilhas importadas</span
                >
              </div>
            </el-tooltip>
            <el-button
              @click="
                () => {
                  dialogVisible = true;
                  isLoadingImportBtb = true;
                }
              "
              :disabled="btnDisabled"
              :loading="isLoadingImportBtb"
              >{{ "Importar planilhas" }}</el-button
            >
          </div>
        </div>
      </el-upload>
    </div>
    <el-dialog
      title="Selecione o mês para importação"
      :visible.sync="dialogVisible"
      width="25%"
      :before-close="handleClose"
    >
      <div class="container">
        <div class="block">
          <el-date-picker
            v-model="period"
            type="month"
            style="width: 100%"
            placeholder="Selecione um mês"
          >
          </el-date-picker>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button
          style="background-color: #eaeaea; color: #515151"
          :disabled="isLoading"
          @click="
            () => {
              isLoadingImportBtb = false;
              dialogVisible = false;
              buttonText = 'Importar planilhas';
            }
          "
          >Cancelar</el-button
        >
        <el-button :loading="isLoading" @click="submit">Confirmar</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<style>
.el-button {
  background: #e87305;
  padding-top: 8px;
  padding-left: 12px;
  padding-right: 12px;
  padding-bottom: 8px;
  color: #fff;
  font-weight: bold;
  font-size: 12px;
}
.el-button:hover {
  background: #c76000;
  color: #fff;
}
.el-button:focus {
  background: #e87305;
  color: #fff;
}
.el-button:disabled {
  background: #e87305;
  opacity: 0.5;
}
.el-button:disabled:hover {
  background: #e87305;
  opacity: 0.5;
}
.text-center {
  display: flex;
  align-items: center;
}
.standards-items {
  border: 1px solid #e4e4e4;
  padding: 10px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  opacity: 0.5;
}
.standards-items:hover {
  opacity: 1;
}
.cell:hover {
  color: #e87305 !important;
}
.cell:active {
  color: #e87305 !important;
}
.cell:focus {
  color: #e87305 !important;
}
.cell:visited {
  color: #e87305 !important;
}
.current {
  color: #e87305 !important;
}
.today {
  color: #e87305 !important;
}
.confirm-items {
  display: flex;
  padding-top: 8px;
  padding-right: 15px !important;
}
.footer-menu-item {
  margin-top: 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.item-name {
  font-size: 14px;
  font-weight: normal;
  color: #515151;
}
.item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 15px;
}
.text-danger {
  font-size: 10px;
  color: rgb(220, 53, 69);
}
.item.danger {
  background: rgba(220, 53, 69, 0.06);
}
.danger {
  background: rgba(220, 53, 69, 0.06);
}
.icon-beaut {
  cursor: pointer;
  margin-right: 4px;
}
.icon-beaut:hover {
  color: #e87305;
}
.items-box {
  margin-top: 10px;
  border: 1px solid #e2e2e2;
}
.el-upload-list {
  visibility: hidden;
}
.el-upload-dragger {
  margin-top: 30px;
  padding: 1px;
  width: 500px !important;
}
.el-upload-dragger:focus {
  margin-top: 30px;
  padding: 1px;
  width: 500px !important;
}
.el-upload-dragger:visited {
  margin-top: 30px;
  padding: 1px;
  width: 500px !important;
}
.el-upload-dragger:hover {
  border-width: 2px;
  padding: 0px;
  border-color: #e87305;
  border-style: dotted;
}
.centered {
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.upload-div {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100% !important;
}
</style>

<script>
import { mapActions } from "vuex";
import store from "../utils/store";
import XLSX from "xlsx";
import api from "../utils/api";
export default {
  name: "Home",
  components: {},
  data() {
    return {
      period: new Date(),
      btnDisabled: true,
      dialogVisible: false,
      isLoadingImportBtb: false,
      standardsVisibled: true,
      isLoading: false,
      buttonText: "Importar planilhas",
      jsonObjects: {
        apportionments: [],
        benefits: [],
        payrolls: [],
        charges: [],
        additional: [],
        date: null,
      },
      standards: [
        { name: "rateio", objectName: "apportionments", required: false },
        { name: "folha", objectName: "payrolls", required: true },
        { name: "encargo", objectName: "charges", required: true },
        { name: "benefício", objectName: "benefits", required: true },
        {
          name: "planilha_cc_servico_terceiros",
          objectName: "additional",
          required: true,
        },
      ],
      fileList: [],
    };
  },
  created() {
    this.updateNavCurrentIndex("1");
    const array_teste = store.state.navItems.map((e) => {
      if (
        e.route === "/" ||
        e.route === "/upload" ||
        e.route === "/apportionmentBylocation"
      ) {
        return { ...e, disabled: false, route: "/upload" };
      } else {
        return { ...e, disabled: true };
      }
    });
    this.updateNavItems_(array_teste);
  },
  methods: {
    ...mapActions(["updateNavItems", "updateNavCurrentIndex"]),
    updateNavItems_(array_teste) {
      this.updateNavItems(array_teste);
    },
    handleRemove(file, fileList) {
      this.fileList = fileList;
    },
    onChange(file) {
      let errorStatus = true;
      if (
        this.fileList.some((elem) => {
          return file.name
            .toUpperCase()
            .trim()
            .normalize("NFD")
            .replace(/[\u0300-\u036f]/g, "")
            .includes(
              elem.name
                .toUpperCase()
                .normalize("NFD")
                .replace(/[\u0300-\u036f]/g, "")
            );
        })
      ) {
        errorStatus = true;
        this.fileList.push({
          ...file,
          popVisible: false,
          error: {
            status: true,
            message: "Arquivo já existe na lista de importação.",
          },
        });
      } else {
        errorStatus = false;
      }
      let position = 0;
      if (!errorStatus) {
        if (
          this.standards.some((elem) => {
            if (
              file.name
                .toUpperCase()
                .trim()
                .normalize("NFD")
                .replace(/[\u0300-\u036f]/g, "")
                .includes(
                  elem.name
                    .toUpperCase()
                    .normalize("NFD")
                    .replace(/[\u0300-\u036f]/g, "")
                )
            ) {
              return true;
            }
            position++;
            return false;
          })
        ) {
          errorStatus = false;
          this.fileList.push({
            ...file,
            name: this.standards[position].name,
            popVisible: false,
            error: { status: false, message: "" },
          });
        } else {
          errorStatus = true;
          this.fileList.push({
            ...file,
            popVisible: false,
            error: {
              status: true,
              message: "Arquivo não está no padrão de nome esperado.",
            },
          });
        }
      }
      let filtered = this.fileList.filter(({ name: n1 }) =>
        this.standards.some(
          ({ name: n2, required: r }) => n1 === n2 && r === true
        )
      );
      if (
        this.fileList.some((e) => e.error.status) ||
        filtered.length !==
          this.standards.filter((elem) => elem.required === true).length ||
        this.fileList.length > this.standards.length
      )
        this.btnDisabled = true;
      else this.btnDisabled = false;
    },
    handleDelete(position) {
      this.fileList.splice(position, 1);
      var filtered = this.fileList.filter(({ name: n1 }) =>
        this.standards.some(
          ({ name: n2, required: r }) => n1 === n2 && r === true
        )
      );
      if (
        this.fileList.some((e) => e.error.status) ||
        filtered.length !==
          this.standards.filter((elem) => elem.required === true).length ||
        this.fileList.length > this.standards.length
      ) {
        this.btnDisabled = true;
      } else {
        this.btnDisabled = false;
      }
    },
    async submit() {
      this.isLoading = true;
      await Promise.all(
        this.fileList.map(async (e) => await this.readExcel(e.name, e.raw))
      );
      try {
        this.jsonObjects.date = this.period;
        if (
          this.jsonObjects["apportionments"] &&
          this.jsonObjects["apportionments"].length === 0
        )
          delete this.jsonObjects.apportionments;
        if (this.isLoadingImportBtb) {
          api
            .put("/integration", {
              ...this.jsonObjects,
            })
            .then(() => {
              this.$message({
                type: "success",
                message: "Planilhas importadas com sucesso!",
              });
              setTimeout(() => {
                this.$router.push({ path: "/" });
              }, 500);
            })
            .catch((err) => {
              this.$message({
                type: "error",
                showClose: true,
                message: err.response.data.error,
                title: err.response.data.error,
              });
              this.isLoading = false;
              this.jsonObjects = {
                apportionments: [],
                benefits: [],
                payrolls: [],
                charges: [],
                additional: [],
                date: null,
              };
            });
        } else {
          this.isLoading = false;
          this.jsonObjects.apportionments = [];
        }
      } catch (error) {
        this.jsonObjects.apportionments = [];
      }
    },
    async readExcel(name, file) {
      const promise = new Promise((resolve, reject) => {
        const fileReader = new FileReader();
        fileReader.readAsArrayBuffer(file);
        fileReader.onload = (e) => {
          const bufferArray = e.target.result;
          const wb = XLSX.read(bufferArray, { type: "array" });
          const sheetIndex = wb.SheetNames.findIndex((e) =>
            e.toLowerCase().includes("sheet")
          );
          const wsName = wb.SheetNames[sheetIndex !== -1 ? sheetIndex : 0];
          const ws = wb.Sheets[wsName];
          const data = XLSX.utils.sheet_to_json(ws, { raw: true });
          resolve(data);
        };
        fileReader.onerror = (error) => {
          reject(error);
        };
      });
      return await promise.then(async (formattedJson) => {
        let obj = formattedJson;
        obj.map((item) => {
          Object.keys(item).forEach((key) => {
            const replacedKey = key.trim().toUpperCase().replace(/\s\s+/g, "");
            if (key !== replacedKey) {
              item[replacedKey] = item[key];
              delete item[key];
            }
          });
        });
        this.jsonObjects[
          this.standards.find((elem) => elem.name === name).objectName
        ] = await obj;
      });
    },
    handleClose() {
      if (!this.isLoading) {
        this.isLoadingImportBtb = false;
        this.dialogVisible = false;
      }
    },
  },
};
</script>
